import { useLazyRef } from '@cocoonspace/shared/hooks/use-lazy-ref.hook'
import { Elements } from '@stripe/react-stripe-js'
import { type StripeElementsOptions, loadStripe } from '@stripe/stripe-js'

import { PaymentProvider } from '~/domains/payments/providers/payment.provider'
import { useStripe } from '~/lib/stripe'

interface StripeProviderProps {
	children: any
}

const options: StripeElementsOptions = {
	locale: 'fr',
}

export const StripeProvider = ({ children }: StripeProviderProps) => {
	const stripePromiseRef = useLazyRef(() =>
		loadStripe(process.env.NEXT_PUBLIC_STRIPE_PK || ''),
	)

	return (
		<Elements
			stripe={stripePromiseRef.current}
			options={options}
		>
			<PaymentProvider service={useStripe}>{children}</PaymentProvider>
		</Elements>
	)
}
